import { useState } from "react";
import { ChevronRight } from "lucide-react";
import Reveal from "@/components/landing/Reveal";
import { LANDING } from "@/constants/testIds";

export default function FAQSection({ block }) {
  const [open, setOpen] = useState(null);
  const items = block?.items || [];
  return (
    <section id="preguntas" className="section-dark py-24 md:py-32">
      <div className="max-w-[900px] mx-auto px-6 lg:px-10">
        <Reveal className="text-center"><span className="eyebrow">Preguntas frecuentes</span></Reveal>
        <Reveal delay={120}>
          <h2 className="text-center mt-4 font-display text-4xl md:text-5xl text-[#0A0A0A]">Todo lo que necesitas saber</h2>
        </Reveal>
        <div className="mt-12 space-y-3">
          {items.map((it, i) => (
            <Reveal key={i} delay={i * 40}>
              <div className={`glass overflow-hidden transition-all ${open === i ? "border-[#FFBF57]/45" : ""}`} data-testid={LANDING.faqItem(i)}>
                <button
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left"
                  onClick={() => setOpen(open === i ? null : i)}
                >
                  <span className="font-display text-base md:text-lg text-[#0A0A0A]">{it.q}</span>
                  <ChevronRight size={16} className={`text-[#FFBF57] transition-transform shrink-0 ${open === i ? "rotate-90" : ""}`} />
                </button>
                {open === i && (
                  <div className="px-5 md:px-6 pb-5 md:pb-6 text-sm text-[#3F3F46] leading-relaxed whitespace-pre-line">
                    {it.a}
                  </div>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
